/** Data de nascimento do passageiro: texto dd/mm/aaaa, vazio até alguém informar. */

export function birthDateInputValue(raw) {
  const s = String(raw || "").trim();
  if (!s || s.startsWith("0000-00-00")) return "";
  const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (iso) return iso[1];
  const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (br) return `${br[3]}-${br[2]}-${br[1]}`;
  return "";
}

export function maskBirthDateTyping(raw) {
  const digits = String(raw || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

function isRealBirthDate(day, month, year) {
  if (month < 1 || month > 12 || day < 1 || year < 1900) return false;
  const today = new Date();
  if (year > today.getFullYear()) return false;
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return false;
  const endToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);
  return dt.getTime() <= endToday.getTime();
}

/** ISO só quando a data está completa e é um dia real, até hoje. */
export function completeBirthDateIso(raw) {
  const iso = birthDateInputValue(raw);
  if (!iso) return "";
  const [year, month, day] = iso.split("-").map(Number);
  if (!isRealBirthDate(day, month, year)) return "";
  return iso;
}

/** O que o campo mostra. Cadastro ou digitação completa vira dd/mm/aaaa; senão fica vazio ou parcial. */
export function birthDateFieldText(stored) {
  const iso = completeBirthDateIso(stored);
  if (iso) {
    const [year, month, day] = iso.split("-");
    return `${day}/${month}/${year}`;
  }
  const raw = String(stored || "").trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return "";
  return maskBirthDateTyping(raw);
}
